import Vue from 'vue'
import router from './router'
import './plugins/element.js'

import './utils/directives.js'
import './utils/components.js'
import VueChatScroll from 'vue-chat-scroll'

Vue.config.productionTip = false
Vue.use(VueChatScroll)

new Vue({
  router,
  template: '<router-view></router-view>',
}).$mount('#app')
Vue.config.devtools = true
